var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"css":false},on:{"before-enter":_vm.setup,"before-leave":_vm.setMaxHeight,"leave":_vm.hide}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }